import React from 'react'
import { useTranslation } from 'next-i18next'
import { useFormContext } from 'react-hook-form'
import InputField from 'modules/ui/molecules/FormComponents/InputField'
import TokenexField from 'modules/tokenex/tokenex-field'

// ACH form data is now part of the combined form data
export interface ACHFormData {
  accountNumber: string
  routingNumber: string
}

const ACHInputs = () => {
  const { t } = useTranslation()
  const form = useFormContext() // Use the form context from parent

  const {
    formState: { errors },
  } = form

  const fieldError = (fieldName: string) => errors[fieldName] as { message: string } | undefined

  return (
    <div id="ach-inputs-container">
      <InputField
        required
        dataId="bank-routing-number-input"
        id="routingNumber"
        label={t('bankDetailsStep.labels.routingNumber', 'Routing number')}
        error={fieldError('routingNumber')}
      />
      <TokenexField
        type="ACH"
        id="accountNumber"
        label={t('bankDetailsStep.labels.accountNumber', 'Account number')}
      />
    </div>
  )
}

export default ACHInputs
